import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useFormikContext } from 'formik';
import _ from 'lodash';

interface SecretPasswordFieldProps {
    name: string;
    /** Formik path of the has* flag returned by the API (e.g. openai.hasApiKey). */
    hasFlagName: string;
    className?: string;
    placeholder?: string;
    autoComplete?: string;
}

/**
 * Password input for server-stored secrets.
 * When the API reports a has* flag, show an "unchanged" placeholder and leave
 * the value empty so prepareForUpdate omits it (server keeps the stored secret).
 */
function SecretPasswordField(props: SecretPasswordFieldProps) {
    const { name, hasFlagName, className, placeholder, autoComplete } = props;
    const { t } = useTranslation();
    const { values } = useFormikContext<AnyObj>();
    const hasSecret = !!_.get(values, hasFlagName);

    return (
        <Field
            type="password"
            name={name}
            autoComplete={autoComplete || 'new-password'}
            placeholder={
                hasSecret
                    ? (t('settings.secret_unchanged') || '••••••••')
                    : placeholder
            }
            className={
                className
                || 'block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6'
            }
        />
    );
}

export default SecretPasswordField;
